import React from 'react';

export default function BroadlyAvatar() {
  return <div className="broadly-avatar"/>;
}
